/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApplicationView, OfficeStatus, OfficeType } from '@gh/builder-shared-data';
import { EnumDictionary, getRouteInitData } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { WaitingService } from '@gh/core-ui';
import { assign, isEmpty } from 'lodash';
import { BuilderApplicationService } from '../../../services';
import { BuilderUserContext } from '../../../user';
import { MasterZone } from '../../resources/master-zone.model';
import { createOffice, Office } from '../../resources/office.model';
import { SwitchToBusinessService } from '../../resources/switch-to-business.service';

@Component({
  standalone: false,
  selector: 'gh-switch-to',
  templateUrl: 'switch-to.component.html',
  styleUrls: ['switch-to.component.scss'],
})
export class SwitchToComponent implements OnInit {

  masterZones: MasterZone[];
  masterZone: MasterZone;
  offices: Office[];
  office: Office;
  disabledOfficeChange: boolean;
  isMasterUser: boolean;
  officeStatus: EnumDictionary<OfficeStatus>;
  officeType: EnumDictionary<OfficeType>;

  constructor(private route: ActivatedRoute,
              private businessService: SwitchToBusinessService,
              private applicationService: BuilderApplicationService,
              private userContext: BuilderUserContext,
              private waitingService: WaitingService,
              private translationService: TranslationService) {

  }

  /**
   * Init component
   */
  ngOnInit(): void {
    assign(this, getRouteInitData(this.route));
    switch (this.userContext.applicationView) {
      case ApplicationView.Corporate:
        this.disabledOfficeChange = true;
        break;
      case ApplicationView.Master:
        this.disabledOfficeChange = true;

        if (this.userContext.masterZone) {
          this.masterZone = this.masterZones[0];
          this.isMasterUser = true;

          this.switchMasterZone(this.masterZone);
        }
        break;
      default:
        break;
    }
  }

  /**
   * Select master zone
   * @param masterzone MasterZone
   *
   * @returns SwitchToComponent
   */
  onMasterZoneSelect(masterzone: MasterZone): void {
    this.switchMasterZone(masterzone);
  }

  /**
   * Change masterzone action
   * @param masterZone MasterZone
   *
   * @returns boolean
   */
  onMasterZoneChange(masterZone: MasterZone): void {
    this.applicationService.openMasterView(masterZone.id);
  }

  /**
   * Change office action
   * @param office Office
   *
   * @returns boolean
   */
  onOfficeChange(office: Office): void {
    this.applicationService.openOfficeView(office.id);
  }

  /**
   * Check if office exist
   * @param office Office
   */
  onOfficeSelect(office: Office): void {
    this.disabledOfficeChange = !office || isEmpty(office.id);
  }

  /**
   *  Load offices by masterzone id
   *  Add first line to office list
   *  @param masterzone MasterZone
   *
   *  @returns SwitchToComponent
   */
  switchMasterZone(masterzone: MasterZone): void {
    this.businessService.findAllOfficesByMaster(masterzone.id).pipe(
      this.waitingService.operator<any>())
      .subscribe((offices) => {
        if (offices.length > 0) {
          offices.unshift(createOffice(this.translationService.get('lbl_switch_to_please_select')));
          this.offices = offices;
        } else {
          this.disabledOfficeChange = true;
          this.offices = [createOffice(this.translationService.get('lbl_switch_to_no_offices'))];
        }
        this.office = this.offices[0];
        this.disabledOfficeChange = true;
      });
  }

  getMZStatus(masterZone?: MasterZone): string {
    if (!masterZone) {
      return '';
    }
    return masterZone.active  ? 'lbl_active' : 'lbl_deactivated';
  }
}
